import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "guide"
    }}>{`Guide`}</h1>
    <p>{`A guide.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_PLACE`}</strong>{` = afterPlace`}</p>
      <p parentName="blockquote">{`Dispatched after a Guide is placed. This event bubbles. This event is not cancelable.`}</p>
    </blockquote>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overridden`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the object originated on a master spread and was overridden. If false, the object either originated on a master spread and was not overridden, or the object did not originate on a master page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`overriddenMasterPageItem`}</strong>{` `}</p>
      <p parentName="blockquote">{`An object that originated on a master page and has been overridden. Can return: PageItem, Guide, Graphic, Movie or Sound.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Page `}<strong parentName="p">{`parentPage`}</strong>{` `}</p>
      <p parentName="blockquote">{`The page on which this page item appears.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`id`}</strong>{` `}</p>
      <p parentName="blockquote">{`The unique ID of the Guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the Guide (a Spread or MasterSpread).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`index`}</strong>{` `}</p>
      <p parentName="blockquote">{`The index of the Guide within its containing object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`allowOverrides`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the master page item can be overridden.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`guideColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color of the guide, specified either as an array of three doubles, each in the range 0 to 255 and representing R, G, and B values, or as a UI color. Can return: Array of 3 Reals (0 - 255) or UIColors enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`HorizontalOrVertical `}<strong parentName="p">{`orientation`}</strong>{` `}</p>
      <p parentName="blockquote">{`The orientation of the guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`location`}</strong>{` `}</p>
      <p parentName="blockquote">{`The location at which to place the guide relative to the current ruler zero point.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`fitToPage`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, horizontal orientation guides stop at the edges of the specified page. If false, the guides extends across the width of the spread and into the pasteboard area.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`viewThreshold`}</strong>{` `}</p>
      <p parentName="blockquote">{`The view magnification as a percentage below which guides are no longer displayed. (Range: 5.0 to 4000.0)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`locked`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the Guide is locked.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Layer `}<strong parentName="p">{`itemLayer`}</strong>{` `}</p>
      <p parentName="blockquote">{`The layer that the Guide is on.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`GuideTypeOptions `}<strong parentName="p">{`guideType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The type of the guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`guideZone`}</strong>{` `}</p>
      <p parentName="blockquote">{`The zone of the guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`label`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that can be set to any string.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`name`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the Guide; this is an alias to the Guide's label property.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`override`}</strong>{`( Page `}<strong parentName="p">{`destinationPage`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Overrides a master page item and places the item on the document page as a new object.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Page`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`destinationPage`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The document page that contains the master page item to override.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`removeOverride`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Removes the override from a previously overridden master page item.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`detach`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Detaches an overridden master page item from the master page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`remove`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Deletes the Guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`move`}</strong>{`( Measurement Unit (Number or String)=any `}<strong parentName="p">{`to`}</strong>{`, Measurement Unit (Number or String)=any `}<strong parentName="p">{`by`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Moves the guide to a new location. Note: Either the to or the by parameter is required; if both parameters are defined, only the to value is used.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Measurement Unit (Number or String)=any`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`to`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The new location of the guide, in the format `}{`[x, y]`}{`. (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Measurement Unit (Number or String)=any`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`by`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The amount to move the guide relative to its current position, in the format `}{`[x, y]`}{`. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Guide `}<strong parentName="p">{`duplicate`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Duplicates the Guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`TransformationMatrix `}<strong parentName="p">{`transformValuesOf`}</strong>{`( CoordinateSpaces `}<strong parentName="p">{`in`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Get the transformation values of the page item.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-2"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`CoordinateSpaces`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`in`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The coordinate space to use`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`resolve`}</strong>{`( Mixed `}<strong parentName="p">{`location`}</strong>{`, CoordinateSpaces `}<strong parentName="p">{`in`}</strong>{`, Boolean `}<strong parentName="p">{`consideringRulerUnits`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Get the coordinates of the given location in the specified coordinate system.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-3"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`location`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The location requested. Can accept: Array of 2 Reals, AnchorPoint enumerator or Array of Arrays of 2 Reals, CoordinateSpaces enumerators, AnchorPoint enumerators, BoundingBoxLimits enumerators or Long Integers.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`CoordinateSpaces`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`in`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The coordinate space to use.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`consideringRulerUnits`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`If true then a ruler location is interpreted using ruler units rather than points. The default value is false. This parameter has no effect unless the reference point is specified relative to a page. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`select`}</strong>{`( SelectionOptions `}<strong parentName="p">{`existingSelection`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Selects the object.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-4"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`SelectionOptions`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`existingSelection`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The selection status of the Guide in relation to previously selected objects. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`insertLabel`}</strong>{`( String `}<strong parentName="p">{`key`}</strong>{`, String `}<strong parentName="p">{`value`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Sets the label to the value associated with the specified key.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-5"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`key`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The key.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`value`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The value.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`extractLabel`}</strong>{`( String `}<strong parentName="p">{`key`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Gets the label value associated with the specified key.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-6"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`key`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The key.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the Guide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Guide `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-7"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-8"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      